import React from "react";

const Loader = () => {
  return (
    <div className="flone-preloader-wrapper">
      <div className="flone-preloader">
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
